<template>
  <router-view />
</template>

<script setup>
import useSettingsStore from "@/store/modules/settings";
import { handleThemeStyle } from "@/utils/theme";

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
<style>
/* 全局样式 */
.colent {
  color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  padding: 0 2rem;
  margin-right: 1rem;
}
.colent:hover {
  color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  padding: 0 2rem;
  margin-right: 1rem;
}
.colent:active {
  color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  background: #fff;
  padding: 0 2rem;
  margin-right: 1rem;
}
.colent:focus-visible {
  outline: none;
}
.colent:hover {
  background: #fff;
}
.search_for {
  background-color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  padding: 0 2rem;
  color: #fff;
}
.search_for:hover {
  background-color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  padding: 0 2rem;
  color: #fff;
}
.search_for:active {
  background-color: rgba(255, 131, 14, 1);
  border: 1px solid rgba(255, 131, 14, 1);
  padding: 0 2rem;
  color: #fff;
}
.search_for:focus-visible {
  outline: none;
}
.custom-form {
  display: flex;
  flex-wrap: wrap;
}
.custom-form .el-form-item {
  flex: 0 0 30%; /* 每行显示三个 */
  box-sizing: border-box; /* 确保 padding 和 border 不影响宽度 */
  padding: 0 10px; /* 可以根据需要调整间距 */
}
.el-message-box__message {
  width: 100%;
}
.el-message-box__message textarea:focus-visible {
  outline: none;
  border-color: transparent; /* 移除边框颜色 */
  box-shadow: none; /* 移除可能存在的阴影 */
}
.linear_measure{
  width: 200px;
}

/* H5导航标题 */
.navigation {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    /* 图标靠左，内容居中 */
    align-items: center;
    /* 垂直居中 */
    padding: 0 10px;
    /* 可选：增加一些内边距 */
    height: 50px;
}

.navigation_content {
    /* 如果你想让内容严格居中，可以这样处理 */
    flex-grow: 1;
    text-align: center;
}

/* H5底部按钮样式 */
.underside{
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: #FFF;
    padding: 20px 0;
}
.underside_title{
    width: 80%;
    margin: auto;
    line-height: 50px;
    border-radius: 30px;
    text-align: center;
    background-color:#FF830E;
    color: #fff;
}
</style>
